import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import cookies from 'react-cookies';
import COOKIES from '../../../config/cookies/cookies';
import { getAddonTotal } from '../../../helpers/addonService';
import WowModal from '../../WowModal';
import PaymentExpressPostCheckout from './PaymentExpressPostCheckout';
import PaymentPostCheckout from './PaymentPostCheckout';

const PaymentModal = ({
  currentRef,
  deviceData,
  failedExpressBuy = false,
  isAuthCheckFinished,
  isAuthenticated,
  orderCompleteHandler,
  orderFailedHandler,
  orderIdFromAPI,
  paymentInstruments,
  selectedAddons,
  selectedVip,
  setShowPaymentModal,
  showPaymentModal,
  secondCheckout,
}) => {
  const [finalOrderAmount, setFinalOrderAmount] = useState(0);
  const [orderSummary, setOrderSummary] = useState({});
  const expressAuthToken = localStorage.getItem(COOKIES.expressAuthToken);

  useEffect(() => {
    const updatedFinalOrderAmount = Number(getAddonTotal(selectedAddons));
    const updatedOrderSummary = {
      addonType: selectedAddons[0].addonType,
      currency:
        selectedAddons[0].addonType === 'PMV'
          ? selectedAddons[0]?.protectMyVoucherPrice?.currency
          : selectedAddons[0]?.extensionPrice?.currency ||
            selectedAddons[0]?.currency,
      dealVoucherProductId: selectedAddons[0].productOrderId,
      finalOrderAmount: updatedFinalOrderAmount,
      orderLineId: selectedAddons[0].orderLineId,
      productOrderId: selectedAddons[0].productOrderId || orderIdFromAPI,
      totalQuantity: selectedAddons.length,
      totalQuantityExceptGiftPack: 0,
    };
    setFinalOrderAmount(updatedFinalOrderAmount);
    setOrderSummary(updatedOrderSummary);
  }, [selectedAddons]);

  return (
    <WowModal
      ariaLabelledBy=""
      backdrop={false}
      centered
      container={currentRef}
      extraClasses="range-modal"
      failedExpressBuy={failedExpressBuy}
      isPostCheckout
      setShowModal={setShowPaymentModal}
      showCloseButton
      showHeader
      showModal={showPaymentModal}
      size="lg"
    >
      {expressAuthToken ? (
        <PaymentExpressPostCheckout
          deviceFingerprintId={deviceData}
          failedExpressBuy={failedExpressBuy}
          finalOrderAmount={finalOrderAmount}
          isAuthCheckFinished={isAuthCheckFinished}
          isAuthenticated={isAuthenticated}
          orderCompleteHandler={orderCompleteHandler}
          orderFailedHandler={orderFailedHandler}
          orderSummary={orderSummary}
          paymentInstruments={paymentInstruments}
          secondCheckout={secondCheckout}
          selectedAddons={selectedAddons}
          setShowPaymentModal={setShowPaymentModal}
        />
      ) : (
        <PaymentPostCheckout
          deviceFingerprintId={deviceData}
          failedExpressBuy={failedExpressBuy}
          finalOrderAmount={finalOrderAmount}
          isAuthCheckFinished={isAuthCheckFinished}
          isAuthenticated={isAuthenticated}
          orderCompleteHandler={orderCompleteHandler}
          orderFailedHandler={orderFailedHandler}
          orderSummary={orderSummary}
          paymentInstruments={paymentInstruments}
          secondCheckout={secondCheckout}
          selectedAddons={selectedAddons}
          selectedVip={selectedVip}
          setShowPaymentModal={setShowPaymentModal}
        />
      )}
    </WowModal>
  );
};
PaymentModal.propTypes = {
  currentRef: PropTypes.object,
  deviceData: PropTypes.string,
  failedExpressBuy: PropTypes.bool,
  isAuthCheckFinished: PropTypes.bool,
  isAuthenticated: PropTypes.bool.isRequired,
  orderCompleteHandler: PropTypes.func,
  orderFailedHandler: PropTypes.func,
  orderIdFromAPI: PropTypes.string,
  paymentInstruments: PropTypes.array,
  secondCheckout: PropTypes.bool,
  selectedAddons: PropTypes.array,
  selectedVip: PropTypes.object,
  setShowPaymentModal: PropTypes.func,
  showPaymentModal: PropTypes.bool,
};

export default PaymentModal;
